var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomClicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 7.333l4.253 3.58-.587.12-.426.08c-.42.087-.66.554-.474.934l.18.386.907 1.96-.947.44-.906-1.953-.174-.387a.656.656 0 00-1.013-.24l-.34.267-.473.38V7.333zm-.494-1.54a.507.507 0 00-.506.507v7.633c0 .28.226.507.506.507.127 0 .234-.04.32-.107L7.767 13.3l1.106 2.413c.087.18.267.287.46.287.074 0 .147 0 .22-.053l1.84-.854c.254-.12.374-.426.24-.673L10.52 12l1.607-.3a.587.587 0 00.286-.173.5.5 0 00-.08-.72l-5.826-4.9-.007.006a.504.504 0 00-.327-.12zM9 6.667V5.333h3.333v1.334H9zm-.78-3.494l1.887-1.886.94.94L9.16 4.113l-.94-.94zM5.667 0H7v3.333H5.667V0zM1.62 9.773l1.887-1.886.94.94-1.887 1.886-.94-.94zm0-7.546l.94-.94 1.887 1.886-.94.94L1.62 2.227zm2.047 4.44H.333V5.333h3.334v1.334z",
    fill: "currentColor"
  })));
}

export default SvgCustomClicked;